import retry, { exponentialBackoff } from '@blockcatio/tabby-library/lib/utilities/retry';
import createPollerMiddleware from '@blockcatio/tabby-library/lib/utilities/poller';
import { isEqual } from 'lodash';

import {
  fetchRecommendedGasPricesUpdate,
  fetchRecommendedGasPricesUpdateFailed,
} from '../actions/app';
import { APP_INIT, APP_SHUTDOWN } from '../actionTypes';

export default ({ fetchGasPrices }) => (store) => {
  const { dispatch } = store;
  return createPollerMiddleware(store, {
    initialState: { lastResult: {} },

    frequency: 90000,

    checkStart: action => action.type === APP_INIT,

    checkStop: action => action.type === APP_SHUTDOWN,

    main: async ({ lastResult }) => {
      try {
        const recommendedGasPrices = await retry(() => fetchGasPrices(), {
          delay: exponentialBackoff(),
        });

        if (!isEqual(recommendedGasPrices, lastResult)) {
          dispatch(fetchRecommendedGasPricesUpdate(recommendedGasPrices));
        }
        return { lastResult: recommendedGasPrices };
      } catch (error) {
        dispatch(fetchRecommendedGasPricesUpdateFailed(error));
        return { lastResult };
      }
    },
  });
};



// WEBPACK FOOTER //
// ./src/middleware/pollRecommendedGasPrices.js